import React, { useState } from "react";
import { TransProps } from "@lingui/react";

// Type
export type typeDataListItem = {
  id: string;
  title?: React.ReactElement<TransProps> | string;
  icon?: React.ReactElement<JSX.Element>;
};

export type typeListItem = {
  id: string;
  checked: boolean;
  title?: React.ReactElement<TransProps> | string;
  icon?: React.ReactElement<JSX.Element>;
};

export type typeSelectPanelSmall = {
  variant?: string;
  label?: React.ReactElement<TransProps> | string;
  dataList: typeDataListItem[];
  checkedId?: string | null;
  setCheckedId: React.Dispatch<React.SetStateAction<string | null>>;
};

export const SelectButtonsSmall: React.FC<typeSelectPanelSmall> = ({
  variant,
  label,
  dataList,
  checkedId,
  setCheckedId,
}) => {
  let focusItem = "";
  let bg600 = "";
  let focusWrapper = "";
  switch (variant) {
    default:
      focusItem = "focus:bg-primary-200";
      bg600 = "bg-primary-600";
      focusWrapper =
        "focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500";
      break;
  }

  const tempCurrentDataList: typeListItem[] = dataList.map((item, index) => {
    return {
      ...item,
      ...{
        checked: item.id === checkedId,
      },
    };
  });

  const [currentDataList, setCurrentDataList] = useState(tempCurrentDataList);

  const onButtonClick = (id: string) => {
    setCurrentDataList(
      currentDataList.map((item, index) => {
        return {
          ...item,
          ...{
            checked: item.id === id,
          },
        };
      }),
    );
    setCheckedId(id);
  };

  return (
    <div className="flex flex-col">
      {label ? (
        <label className="block mb-1 text-sm font-medium text-gray-700 text-left">
          {label}
        </label>
      ) : null}
      <div className={`rounded-sm${" " + focusWrapper}`}>
        {currentDataList.map((item, index) => {
          return (
            <button
              key={index}
              className={`focus:outline-none border-t border-b text-xs py-1 px-2 border-r
                                ${currentDataList.length - 1 === index ? " rounded-r" : ""}
                                ${index === 0 ? " rounded-l border-l" : ""}
                                ${item.checked ? ` ${bg600} text-white font-bold` : ` ${focusItem}`}
                            `}
              type="button"
              onClick={() => onButtonClick(item.id)}
            >
              {item.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};
